import React from 'react';

import {
  Box,
} from '@mui/material';

import PermIdentity from '@mui/icons-material/PermIdentity';

import useSessionCountDown from '../../services/hooks/useSessionCountDown';

const Timer = () => {
  const { timer, timerColor } = useSessionCountDown();

  return (
    <Box
      display='flex'
      justifyContent='center'
      alignItems='center'
      style={{ color: timerColor || 'red' }}
    >
      <PermIdentity />
      {timer}
    </Box>
  );
};

export default Timer;
